import React from 'react';

const Unauthorized = () => {
  return (
    <div style={{ textAlign: 'center' }}>
      <img
        src={require('../../../images/unauthorized.png')}  // Update the path to your image file
        alt="Unauthorized Access"
        style={{ maxWidth: '100%', maxHeight: '100%', margin: '20px auto' }}
      />
    </div>
  );
};

export default Unauthorized;
